module.exports = __webpack_public_path__ + "step1_C2P_okuta_bridal.4528cec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_C2P_okuta_bridal.jpg
// module id = GF++
// module chunks = 0